/*!
 * Tutku Home — "5.000₺ üzeri sepette Lavinya 10 Parça 5₺" sepet cross-sell'i
 * ---------------------------------------------------------------------------
 * Reçete kardeşi: e-ticaret/playbook-shopify-bogo-sepette-set.md (A yolu)
 * Kurulum notu:   markalar/tutku/is/tema/HEDIYE-KURULUM.md
 *
 * NE YAPAR
 *   1) Sepet çekmecesine (ve /cart sayfasına) kampanya kutusu basar:
 *      - eşiğin altında: "5.000₺'ye X₺ kaldı" + ilerleme çubuğu  → sepet ortalamasını iter
 *      - eşiğin üstünde: "Hediyeni ekle — 5₺" butonu             → TEK TIKLA ekler
 *      - hediye sepetteyse: "Hediyen sepette — 5₺"
 *   2) Ekledikten SONRA sepeti geri okur: satır gerçekten 5₺ değilse ürünü
 *      hemen çıkarır. (Eşiği tahmin etmeyiz — Shopify'a sorar, doğrularız.)
 *   3) 🔴 GERİ DÜŞME KORUMASI: müşteri hediyeyi ekleyip sonra sepetten ürün
 *      çıkarırsa toplam 5.000₺'nin altına iner, indirim düşer ve hediye
 *      sepette tam fiyatla kalırdı. Her sepet değişiminde kontrol edilir,
 *      indirimsiz kalan hediye satırı otomatik çıkarılır + müşteriye söylenir.
 *   4) İndirimli hediye satırının adet kutusu gizlenir (2. adet tam fiyattan gider).
 *
 * 🔴 SCRIPT YALNIZ KENDİ EKLEDİĞİ SATIRI YÖNETİR (2026-09-15).
 *   Hediye eklenirken satıra gizli `_hediye` imzası konur; müşteri aynı ürünü
 *   ürün sayfasından NORMAL fiyatına eklediğinde satır imzasızdır ve script ona
 *   dokunmaz. Önceden her Lavinya satırı "hediye" sayılıyordu: eşiğin altındaki
 *   müşteri ürünü sepete koyamıyordu, script siliyordu — ürün satılamıyordu.
 *
 * FİYATA DOKUNMAZ. 5₺'yi Shopify'ın otomatik indirimi sağlar:
 *   "5.000₺ ve üzeri alışverişlerde 10 parça lavinya flowers kahvaltı takımı 5₺"
 *   (X Alana Y Bedava · 5.000₺ → 1 adet · her birinden 394₺ · sipariş başına 1)
 *   ⚠️ İndirim SABİT TUTAR: ürünün fiyatı değişirse burada da güncellenmeli
 *   (08 Eyl 2026'da fiyat 899→399₺ düştü, indirim 894₺ kaldı ⇒ hediye 7 gün 0₺ gitti).
 *   İndirim kapalıysa bu script hiçbir şeyi 5₺ yapmaz; kutu da "hazır" durumuna
 *   geçse bile ekleme sonrası doğrulama ürünü geri çıkarır.
 *
 * ⚠️ TEMA BAĞIMLILIĞI (Foxtheme HYPER):
 *    - kutu `.foxkit-cart-goal-hook` div'inin altına giriyor (hem çekmece hem /cart)
 *    - adet kutuları `quantity-input` + `[data-quantity-variant-id]` ile bulunuyor
 *    - sepet tazeleme: document'e `cart:refresh` olayı (cart.js içindeki CartDrawer dinler)
 *    Başka temada bu üç kancayı uyarla; geri kalan mantık tema-bağımsızdır.
 */
(function () {
  'use strict';

  /* ------------------------------ AYARLAR ------------------------------ */
  var GIFT_VARIANT_ID = 47670641492226;     // Lavinya Flowers 10 Parça 4 Kişilik Kahvaltı Takımı
  var THRESHOLD = 500000;                   // 5.000₺ — kuruş cinsinden
  var GIFT_MAX_PRICE = 1000;                // hediye satırı bu tutarın altındaysa "indirim işlemiş" (10₺ tolerans)
  var GIFT_FLAG = '_hediye';                // script'in eklediği satırın gizli imzası (alt çizgi = checkout'ta görünmez)
  var GIFT_TITLE = 'Lavinya Flowers 10 Parça Kahvaltı Takımı';
  var GIFT_IMAGE =
    'https://cdn.shopify.com/s/files/1/0803/5844/1218/files/anagorsel_d1f78138-5053-4001-a17c-3ec1a882b2e2_200x.png?v=1776506935';

  var TXT = {
    uzak: function (kalan) {
      return '<b>' + money(kalan) + '</b> daha ekle, bu ürün <b>5₺</b> olsun';
    },
    hazir: 'Tebrikler! Hediyeni <b>5₺</b>’ye ekleyebilirsin.',
    sepette: 'Hediyen sepette — <b>5₺</b> 🎁',
    ekleniyor: 'Ekleniyor…',
    dustu: 'Sepet 5.000₺’nin altına indiği için hediye çıkarıldı.',
    olmadi: 'Kampanya koşulu sağlanmadı, hediye çıkarıldı.',
    stok: 'Hediye ürünün stoğu tükendi.',
    btn: 'Hediyeni ekle — 5₺'
  };

  /* ------------------------------ YARDIMCI ----------------------------- */
  function money(cents) {
    var v = Math.max(0, Math.round(cents / 100));
    return v.toLocaleString('tr-TR') + '₺';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  /** Script'in kendi eklediği hediye satırı mı? (gizli imza) */
  function isFlagged(item) {
    return !!(item.properties && item.properties[GIFT_FLAG]);
  }

  /** Bu satır script'in yönettiği hediye satırı mı?
   *  - imzalı           → bu script ekledi
   *  - imzasız + indirimli → imza kuralından ÖNCE eklenmiş, hâlâ açık sepet (geçiş)
   *  İmzasız + tam fiyat = müşterinin normal alışverişi ⇒ script ASLA dokunmaz. */
  function isManagedGift(item) {
    return item.variant_id === GIFT_VARIANT_ID && (isFlagged(item) || isDiscounted(item));
  }

  /** Eşiğe sayan tutar = hediye satırları HARİÇ, diğer indirimler DÜŞÜLMÜŞ toplam.
   *  Normal fiyatına alınan Lavinya eşiğe SAYAR (müşteri parasını ödüyor).
   *  İndirim sonrası fiyatı kullanmak bilinçli: Shopify eşiği daha cömert hesaplarsa
   *  butonu bir tık geç göstermiş oluruz — asla tutmayacak bir 5₺ vaadi vermeyiz. */
  function qualifyingTotal(cart) {
    var t = 0;
    (cart.items || []).forEach(function (it) {
      if (isManagedGift(it)) return;
      t += typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price;
    });
    return t;
  }

  /* 🔴 Satır kimliği olarak `key` kullanılır, `line` index'i DEĞİL.
     Index'le silmek yanlış satırı siler: sepet arada değişirse (tema kendi isteğini
     yollar, müşteri adet oynatır, ikinci silme isteği sırayı kaydırır) index başka
     ürünü gösterir ve sepet boşalabilir. `key` satıra sabittir. */
  function giftLines(cart) {
    var out = [];
    (cart.items || []).forEach(function (it, i) {
      if (isManagedGift(it)) out.push({ item: it, key: it.key, line: i + 1, flagged: isFlagged(it) });
    });
    return out;
  }

  function isDiscounted(item) {
    var per = (typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price) / item.quantity;
    return per <= GIFT_MAX_PRICE;
  }

  function refreshTheme() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    /* /cart sayfasında cart-drawer yoksa olay kimseye ulaşmaz → sayfayı tazele */
    if (!document.querySelector('cart-drawer')) {
      setTimeout(function () {
        window.location.reload();
      }, 100);
    }
  }

  /* -------------------------- SEPET İŞLEMLERİ -------------------------- */
  var busy = false;

  function addGift() {
    if (busy) return;
    busy = true;
    setNote(TXT.ekleniyor, true);

    var props = {};          /* ES5: değişken anahtarlı nesne tek adımda kurulamaz */
    props[GIFT_FLAG] = '1';

    /* Eşik kontrolü ekleme ANINDA tekrar yapılır: buton bir şekilde görünür kalmışsa
       (eski DOM, geç gelen sepet cevabı) eşik altında ekleyip sonra silmeye çalışmayız —
       hiç eklemeyiz. Ekle-sonra-sil turu sepeti riske atan tek akıştı. */
    getCart()
      .then(function (cart) {
        if (qualifyingTotal(cart) < THRESHOLD) {
          busy = false;
          sync();
          throw new Error('esik-alti');
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* İmza şart: bu satırı script ekledi ⇒ geri düşmede yalnız bunu çıkarırız. */
          body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return getCart();
      })
      .then(function (cart) {
        /* DOĞRULAMA: gerçekten 5₺ oldu mu? Olmadıysa geri al.
           Yalnız imzalı satırlara bakılır — müşterinin normal aldığı satır burayı ilgilendirmez. */
        var lines = giftLines(cart).filter(function (l) {
          return l.flagged;
        });
        var ok = lines.length > 0 && lines.every(function (l) {
          return isDiscounted(l.item);
        });
        if (ok) {
          busy = false;
          refreshTheme();
          return;
        }
        return removeGift(TXT.olmadi);
      })
      .catch(function (e) {
        busy = false;
        /* eşik altı = hata değil, sessizce vazgeç (kutu zaten "X₺ kaldı"ya döndü) */
        if (e && e.message === 'esik-alti') return;
        setNote(TXT.stok, false);
      });
  }

  /** Hediyeyi sepetten çıkar — YALNIZ script'in imzaladığı satırlar.
   *  Müşterinin ürün sayfasından normal fiyatına eklediği satıra dokunulmaz.
   *  sadeceIndirimsiz=true ise imzalı satırlardan indirimi düşmüş olanlar silinir. */
  function removeGift(mesaj, sadeceIndirimsiz) {
    return getCart()
      .then(function (cart) {
        var lines = giftLines(cart).filter(function (l) {
          return l.flagged && (!sadeceIndirimsiz || !isDiscounted(l.item));
        });
        if (!lines.length) return null;

        /* 🔴 GÜVENLİK AĞI: bu script sepeti ASLA topluca boşaltmaz.
           Silinecek satır sayısı sepetteki satırların tamamıysa ve sepette hediye
           dışında ürün varsa, bir şey yanlış gitmiştir → hiçbir şey silme. */
        var toplamSatir = (cart.items || []).length;
        if (lines.length >= toplamSatir && toplamSatir > 1) return null;

        /* Silme `key` ile: satır kimliği sabittir, index kayması yanlış ürünü silemez. */
        var chain = Promise.resolve();
        lines.forEach(function (l) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: l.key, quantity: 0 })
            });
          });
        });
        return chain;
      })
      .then(function () {
        busy = false;
        if (mesaj) flash(mesaj);
        refreshTheme();
      })
      .catch(function () {
        busy = false;
      });
  }

  /* ------------------------------ ARAYÜZ ------------------------------- */
  var STYLE_ID = 'tk-hediye-style';
  var CSS =
    '.tk-hediye{display:flex;gap:12px;align-items:center;padding:12px;border:1px solid rgba(0,0,0,.12);' +
    'border-radius:10px;margin:0 0 12px;background:rgba(0,0,0,.02);font-size:13px;line-height:1.35}' +
    '.tk-hediye img{width:52px;height:52px;object-fit:cover;border-radius:8px;flex:none}' +
    '.tk-hediye__body{flex:1;min-width:0}' +
    '.tk-hediye__t{font-weight:600;margin-bottom:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.tk-hediye__m{opacity:.85}' +
    '.tk-hediye__bar{height:4px;border-radius:4px;background:rgba(0,0,0,.1);margin-top:7px;overflow:hidden}' +
    '.tk-hediye__bar i{display:block;height:100%;background:currentColor;transition:width .3s}' +
    '.tk-hediye__btn{flex:none;border:0;border-radius:8px;padding:9px 13px;font-size:13px;font-weight:600;' +
    'cursor:pointer;background:#1f1f1f;color:#fff}' +
    '.tk-hediye__btn[disabled]{opacity:.5;cursor:default}' +
    '.tk-hediye--sepette{background:rgba(46,140,70,.08);border-color:rgba(46,140,70,.35)}' +
    '.tk-hediye__flash{margin-top:6px;font-size:12px;color:#a33}';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function boxHTML() {
    return (
      '<img src="' + GIFT_IMAGE + '" alt="" loading="lazy">' +
      '<div class="tk-hediye__body">' +
      '<div class="tk-hediye__t">🎁 ' + GIFT_TITLE + '</div>' +
      '<div class="tk-hediye__m"></div>' +
      '<div class="tk-hediye__bar"><i style="width:0%"></i></div>' +
      '<div class="tk-hediye__flash" hidden></div>' +
      '</div>' +
      '<button type="button" class="tk-hediye__btn" hidden>' + TXT.btn + '</button>'
    );
  }

  /** Kutuyu her kancanın altına bir kez koy (çekmece + /cart ayrı ayrı). */
  function boxes() {
    var list = [];
    document.querySelectorAll('.foxkit-cart-goal-hook').forEach(function (hook) {
      var box = hook.nextElementSibling;
      if (!box || !box.classList || !box.classList.contains('tk-hediye')) {
        box = document.createElement('div');
        box.className = 'tk-hediye';
        box.innerHTML = boxHTML();
        box.querySelector('.tk-hediye__btn').addEventListener('click', addGift);
        hook.insertAdjacentElement('afterend', box);
      }
      list.push(box);
    });
    return list;
  }

  function setNote(html, busyState) {
    boxes().forEach(function (b) {
      b.querySelector('.tk-hediye__m').innerHTML = html;
      var btn = b.querySelector('.tk-hediye__btn');
      if (busyState) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');
    });
  }

  function flash(msg) {
    boxes().forEach(function (b) {
      var f = b.querySelector('.tk-hediye__flash');
      f.textContent = msg;
      f.hidden = false;
      setTimeout(function () {
        f.hidden = true;
      }, 6000);
    });
  }

  /** İndirimli hediye satırının adet kutusunu gizle (2. adet tam fiyattan gider).
   *  Müşteri gerçekten 2 adet almak isterse ikinci satır ayrı gelir, ona dokunmayız —
   *  normal fiyatına alınan satırın adet kutusu her zaman açık kalır. */
  function lockQuantity(cart) {
    var kilitli = giftLines(cart)
      .filter(function (l) {
        return isDiscounted(l.item);
      })
      .map(function (l) {
        return String(l.line);
      });

    document.querySelectorAll('quantity-input').forEach(function (q) {
      var inp = q.querySelector('[data-quantity-variant-id="' + GIFT_VARIANT_ID + '"]');
      if (!inp) return;
      q.style.display = kilitli.indexOf(String(inp.dataset.index)) !== -1 ? 'none' : '';
    });
  }

  /* ------------------------------ SENKRON ------------------------------ */
  function sync() {
    if (busy) return;
    ensureStyle();
    if (!document.querySelector('.foxkit-cart-goal-hook')) return;

    getCart().then(function (cart) {
      var list = boxes();
      if (!list.length) return;

      var total = qualifyingTotal(cart);
      var lines = giftLines(cart);
      /* Yalnız İMZALI satırlar geri düşmeden etkilenir. Müşterinin normal fiyatına
         eklediği Lavinya satırı buraya hiç girmez (isManagedGift onu dışarıda tutar). */
      var indirimsiz = lines.filter(function (l) {
        return l.flagged && !isDiscounted(l.item);
      });

      /* 🔴 GERİ DÜŞME: hediye sepette ama artık 5₺ değil → çıkar */
      if (indirimsiz.length) {
        busy = true;
        removeGift(total < THRESHOLD ? TXT.dustu : TXT.olmadi, true);
        return;
      }

      lockQuantity(cart);

      var durum = lines.length ? 'sepette' : total >= THRESHOLD ? 'hazir' : 'uzak';
      var oran = Math.min(100, Math.round((total / THRESHOLD) * 100));

      list.forEach(function (b) {
        b.hidden = (cart.item_count || 0) === 0;
        b.classList.toggle('tk-hediye--sepette', durum === 'sepette');
        b.querySelector('.tk-hediye__m').innerHTML =
          durum === 'sepette' ? TXT.sepette : durum === 'hazir' ? TXT.hazir : TXT.uzak(THRESHOLD - total);
        b.querySelector('.tk-hediye__bar').hidden = durum !== 'uzak';
        b.querySelector('.tk-hediye__bar i').style.width = oran + '%';
        var btn = b.querySelector('.tk-hediye__btn');
        btn.hidden = durum !== 'hazir';
        btn.removeAttribute('disabled');
      });
    });
  }

  /* ------------------------------ BAĞLANTI ----------------------------- */
  function boot() {
    sync();

    /* 1) Temanın kendi sepet olayı — ekleme/silme/adet değişiminin hepsini kapsar */
    try {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(sync, 120);
        });
      }
    } catch (e) {
      /* sessiz geç — sepet akışını asla bozma */
    }

    /* 2) Tema sepet bölümünü yeniden bastığında kutu silinir → yeniden koy.
     *    ⚠️ sync() de DOM'a yazıyor: gözlemciyi koşulsuz tetiklersek sonsuz döngü
     *    (ve saniyede bir /cart.js) olur. Sadece kutu GERÇEKTEN kaybolduysa çalış. */
    var obs = new MutationObserver(function () {
      var eksik = false;
      document.querySelectorAll('.foxkit-cart-goal-hook').forEach(function (hook) {
        var n = hook.nextElementSibling;
        if (!n || !n.classList || !n.classList.contains('tk-hediye')) eksik = true;
      });
      if (!eksik) return;
      clearTimeout(obs._t);
      obs._t = setTimeout(sync, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });

    /* 3) Çekmece açılışı (başka sekmede değişmiş sepet ihtimali) */
    document.addEventListener('cart:refresh', function () {
      setTimeout(sync, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
